import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import orderService from '../OrderService';
import { BaseBarcode } from '../../controls/BaseBarcode';
import { BaseCombobox } from '../../controls/BaseCombobox';
import { DefaultImage, LeftRightOption, ProductOptionCategory } from '../../infrastructure/AppConstants';
import Toast from '../../controls/BaseToast';
import authService from '../../api-authorization/AuthorizeService'

export class CustomizedMachineStepView extends Component {
    static displayName = CustomizedMachineStepView.name;
    leftLines = [];
    leftSpecsMatrixes = [];
    rightLines = [];
    rightSpecsMatrixes = [];
    constructor(props) {
        super(props);

        var customizedMachineModel = props.model.customizedMachineModel;
        let leftEnclousureType = '-1';
        let leftWireless = '0';
        let leftLine = '-1';
        let leftSpecsMatrix = '-1';
        let leftColor = '-1';
        let rightEnclousureType = '-1';
        let rightWireless = '0';
        let rightLine = '-1';
        let rightSpecsMatrix = '-1';
        let rightColor = '-1';

        if (customizedMachineModel) {
            var array = customizedMachineModel.split(';');
            if (array.length === 2) {
                var childArray = array[0].split(',');
                if (childArray.length === 5) {
                    leftEnclousureType = childArray[0];
                    leftWireless = childArray[1];
                    leftLine = childArray[2];
                    leftSpecsMatrix = childArray[3];
                    leftColor = childArray[4];
                }
                var rChildArray = array[1].split(',');
                if (rChildArray.length === 5) {
                    rightEnclousureType = rChildArray[0];
                    rightWireless = rChildArray[1];
                    rightLine = rChildArray[2];
                    rightSpecsMatrix = rChildArray[3];
                    rightColor = rChildArray[4];
                }
            }
        }

        //console.log(customizedMachineModel);
        //var defaultLeftColor = leftColor === "-2" ? "-2" : "-1";
        //var defaultRightColor = rightColor === "-2" ? "-2" : "-1";

        this.state = {
            uploading: false, data: null,
            leftEnclousureType: leftEnclousureType, leftWireless: leftWireless, leftLine: leftLine, leftSpecsMatrix: leftSpecsMatrix, leftColor: leftColor,
            rightEnclousureType: rightEnclousureType, rightWireless: rightWireless, rightLine: rightLine, rightSpecsMatrix: rightSpecsMatrix, rightColor: rightColor,
            antiEarwaxDevice: props.model.antiEarwaxDevice, vent: props.model.vent, onlyForRICSeries: props.model.onlyForRICSeries,
            attachment: props.model.attachment,
            defaultEnclosureColors: [],
            leftDisplayType: '', rightDisplayType: ''
        };
        this.handleLeftChange = this.handleLeftChange.bind(this);
        this.handleRightChange = this.handleRightChange.bind(this);
        this.handleSelectChanged = this.handleSelectChanged.bind(this);
        this.handleAntiEarwaxDeviceChanged = this.handleAntiEarwaxDeviceChanged.bind(this);
        this.handleVentChanged = this.handleVentChanged.bind(this);
        this.handleOnlyForRICSeriesChanged = this.handleOnlyForRICSeriesChanged.bind(this);
        this.handleAttachmentChanged = this.handleAttachmentChanged.bind(this);
        this.leftLineText = '';
        this.rightLineText = '';
        // console.log(this.state);
    }

    handleAttachmentChanged(e) {
        if (this.state.data) {
            let attachment = e.target.value;
            this.setState({ attachment: attachment });
        }
    }

    handleOnlyForRICSeriesChanged(e) {
        if (this.state.data) {
            this.setState({ onlyForRICSeries: e });
        }
    }

    handleVentChanged(e) {
        if (this.state.data) {
            this.setState({ vent: e });
        }
    }
    handleAntiEarwaxDeviceChanged(e) {
        if (this.state.data) {
            this.setState({ antiEarwaxDevice: e });
        }
    }

    handleSelectChanged(e) {
        var handler = this.onSelectChanged;
        if (handler) {
            handler(e);
        }
    }

    async componentDidMount() {
        await this.populateProductOptionData();
        this.props.onRef(this);
        const leftLine = this.state.leftLine;
        const rightLine = this.state.rightLine;

        if (leftLine != -1) {
            await this.setSpecialParameterByLine(leftLine, LeftRightOption.LeftEarOption, this.state.leftEnclousureType);
        }
        if (rightLine != -1) {
            await this.setSpecialParameterByLine(rightLine, LeftRightOption.RightEarOption, this.state.rightEnclousureType);
        }
        //console.log(this.state.leftEnclosureColors);
        //const leftEnclosureColors = this.state.leftEnclosureColors;
        //const rightEnclosureColors = this.state.rightEnclosureColors;

        //if (leftEnclosureColors && leftEnclosureColors.length > 0 && this.state.leftColor == -1) {
        //    this.setState({ leftColor: leftEnclosureColors[0].id })
        //}
        //if (rightEnclosureColors && rightEnclosureColors.length > 0 && this.state.rightColor == -1) {
        //    this.setState({ rightColor: rightEnclosureColors[0].id })
        //}
    }

    async populateProductOptionData() {
        const data = await orderService.GetCustomizedMachineProductOptions(true, this.props.deliverAccountCode);
        if (data != null) {
            data.leftEnclosureColors = data.enclosureColors;
            data.rightEnclosureColors = data.enclosureColors;
            data.leftAntiEarwaxDevice = data.antiEarwaxDevice;
            data.rightAntiEarwaxDevice = data.antiEarwaxDevice;
            data.leftVent = data.vent;
            data.rightVent = data.vent;
            data.leftOnlyForRICSeries = data.onlyForRICSeries;
            data.rightOnlyForRICSeries = data.onlyForRICSeries;
            data.defaultAttachment = data.attachment;
            this.setState({ data: data, loading: false, defaultEnclosureColors: data.enclosureColors });

        }
    }


    async handleLeftChange(e) {
        let target = e.target;
        let value = target.value;
        let name = target.name;

        if (name == 'leftEnclousureType') {
            let lable = document.getElementById('l' + value);
            let displayName = lable.innerHTML;
            let otherDisplayType = this.state.rightDisplayType;
            if ((otherDisplayType && otherDisplayType.includes('RIC') && !displayName.includes("RIC")) ||
                (otherDisplayType && !otherDisplayType.includes('RIC') && displayName.includes("RIC"))) {

                Toast.warn('RicTypeSelectionNote');
                //return;
            }
            this.setState({ leftEnclousureType: value, leftDisplayType: displayName, leftLine: -1, leftSpecsMatrix: -1, leftColor: -1 });
            await this.setSpecialParameterByLine(-1, LeftRightOption.LeftEarOption, value);
        }
        else if (name == 'leftWireless') {
            this.setState({ leftWireless: value, leftLine: -1, leftSpecsMatrix: -1, leftColor: -1 });
            await this.setSpecialParameterByLine(-1, LeftRightOption.LeftEarOption, this.state.leftEnclousureType);
        }
        else if (name == 'leftLine') {
            let text = target.options[target.selectedIndex].text;
            this.leftLineText = text;
            //let defaultColor = this.state.defaultLeftColor;
            //if (text && ((text.startsWith("Insio") && text.endsWith("AX")) || text.startsWith("Bicore") || text.startsWith("BiCore"))) {
            //    defaultColor = "-2";
            //}
            //else {
            //    defaultColor = "-1";
            //}
            //var leftColor = this.state.leftColor;
            //if (leftColor === "-1" || leftColor === "-2") {
            //    leftColor = defaultColor;
            //}
            //this.setState({ leftLine: value, defaultLeftColor: defaultColor, leftColor: leftColor });
            this.setState({ leftLine: value });
            await this.setSpecialParameterByLine(value, LeftRightOption.LeftEarOption, this.state.leftEnclousureType);

        }
        else if (name == 'leftSpecsMatrix') {
            this.setState({ leftSpecsMatrix: value });
        }
        else if (name == 'leftEnclosureColor') {
            this.setState({ leftColor: value });
            // console.log(value);

        }
    }

    async handleRightChange(e) {
        let target = e.target;
        let value = target.value;
        let name = target.name;

        if (name == 'rightEnclousureType') {
            let lable = document.getElementById('l' + value);
            let displayName = lable.innerHTML;
            let otherDisplayType = this.state.leftDisplayType;
            if ((otherDisplayType && otherDisplayType.includes('RIC') && !displayName.includes("RIC")) ||
                (otherDisplayType && !otherDisplayType.includes('RIC') && displayName.includes("RIC"))) {

                Toast.warn('RicTypeSelectionNote');
                //return;
            }
            this.setState({ rightEnclousureType: value, rightDisplayType: displayName, rightLine: -1, rightSpecsMatrix: -1, rightColor: -1 });
            await this.setSpecialParameterByLine(-1, LeftRightOption.RightEarOption, value);
        }
        else if (name == 'rightWireless') {
            this.setState({ rightWireless: value, rightLine: -1, rightSpecsMatrix: -1, rightColor: -1 });
            await this.setSpecialParameterByLine(-1, LeftRightOption.RightEarOption, this.state.rightEnclousureType);
        }
        else if (name == 'rightLine') {
            let text = target.options[target.selectedIndex].text;
            this.rightLineText = text;
            //let defaultColor = this.state.defaultRightColor;
            //if (text && ((text.startsWith("Insio") && text.endsWith("AX")) || text.startsWith("Bicore") || text.startsWith("BiCore"))) {
            //    defaultColor = "-2";
            //}
            //else {
            //    defaultColor = "-1";
            //}
            //var rightColor = this.state.rightColor;
            //if (rightColor === "-1" || rightColor === "-2") {
            //    rightColor = defaultColor;
            //}
            //this.setState({ rightLine: value, defaultRightColor: defaultColor, rightColor: rightColor });
            this.setState({ rightLine: value });
            await this.setSpecialParameterByLine(value, LeftRightOption.RightEarOption, this.state.rightEnclousureType);
        }
        else if (name == 'rightSpecsMatrix') {
            this.setState({ rightSpecsMatrix: value });
        }
        else if (name == 'rightEnclosureColor') {
            this.setState({ rightColor: value });
        }
    }

    getLines(enclosureId, wl) {
        let data = this.state.data;
        if (data) {
            var model = data.customizedMachineModel;
            var lines = new Array();
            for (let i = 0; i < model.length; i++) {
                if (model[i].enclosureType.id == enclosureId && wl == model[i].wireless) {
                    let id = model[i].line.id;
                    if (!this.contains(lines, id)) {
                        lines.push({ id: id, name: model[i].line.name, order: model[i].line.order });
                    }

                }
            }
            if (lines.length > 0) {
                return lines.sort((x, y) => {
                    if (x.order < y.order) { return -1; }
                    if (x.order > y.order) { return 1; }
                    return 0;
                });
            }
            return lines;
        }

        return null;
    }

    getMatrix(enclosure, line, wl) {
        let data = this.state.data;
        if (data) {
            var model = data.customizedMachineModel;
            var matrixes = new Array();
            for (let i = 0; i < model.length; i++) {
                if (model[i].enclosureType.id == enclosure && model[i].line.id == line && wl == model[i].wireless) {
                    let id = model[i].specsMatrix.id;
                    if (!this.contains(matrixes, id)) {
                        matrixes.push({ id: id, name: model[i].specsMatrix.name, order: model[i].specsMatrix.order });
                    }
                }
            }
            //  console.log(matrixes);
            if (matrixes.length > 0) {
                return matrixes.sort((x, y) => {
                    const tempX = (x.name.match(/\d+/g) || []).join('');
                    const tempy = (y.name.match(/\d+/g) || []).join('');
                    return tempX - tempy;
                    //if (x.order < y.order) { return -1; }
                    //if (x.order > y.order) { return 1; }
                    //return 0;
                });
            }

            return matrixes;
        }

        return null;
    }

    extractAndConcatenateNumbers(str) {

        const numbers = str.match(/\d+/g) || [];
        return numbers.join('');
    }

    contains(array, id) {
        var returnValue = false;
        for (let i = 0; i < array.length; i++) {
            if (array[i].id === id) {
                returnValue = true;
                break;
            }
        }

        return returnValue;
    }

    validate() {
        let leftRightOption = this.props.leftRightOption;
        if (leftRightOption === LeftRightOption.LeftEarOption) {
            if (this.state.leftEnclousureType == -1) {
                return { state: false, msg: "CustomizedMachineModelRequired" };
            }
            if (this.state.leftLine == -1) {
                return { state: false, msg: "LineRequired" };
            }
            else {
                let found = this.leftLines.find((i) => { return i.id === this.state.leftLine });
                if (!found) {
                    return { state: false, msg: "LineRequired" };
                }
            }
            if (this.state.leftSpecsMatrix == -1) {
                return { state: false, msg: "MatrixSpecRequired" };
            }
            else {
                let found = this.leftSpecsMatrixes.find((i) => { return i.id === this.state.leftSpecsMatrix });
                if (!found) {
                    return { state: false, msg: "MatrixSpecRequired" };
                }
            }
        }
        else if (leftRightOption === LeftRightOption.RightEarOption) {
            if (this.state.rightEnclousureType == -1) {
                return { state: false, msg: "CustomizedMachineModelRequired" };
            }
            if (this.state.rightLine == -1) {
                return { state: false, msg: "LineRequired" };
            }
            else {
                let found = this.rightLines.find((i) => { return i.id === this.state.rightLine });
                if (!found) {
                    return { state: false, msg: "LineRequired" };
                }
            }
            if (this.state.rightSpecsMatrix == -1) {
                return { state: false, msg: "MatrixSpecRequired" };
            }
            else {
                let found = this.rightSpecsMatrixes.find((i) => { return i.id === this.state.rightSpecsMatrix });
                if (!found) {
                    return { state: false, msg: "MatrixSpecRequired" };
                }
            }
        }
        else {

            if (this.state.leftEnclousureType == -1 || this.state.rightEnclousureType == -1) {
                return { state: false, msg: "CustomizedMachineModelRequired" };
            }

            //  const { leftDisplayType, rightDisplayType } = this.state;
            var enclosureTypes = this.state.data.enclosureTypes;
            var leftEnclousureType = enclosureTypes.filter(x => x.id === this.state.leftEnclousureType);
            var rightEnclousureType = enclosureTypes.filter(x => x.id === this.state.rightEnclousureType);
            if (leftEnclousureType.length > 0 && rightEnclousureType.length > 0) {
                if ((leftEnclousureType[0].name.includes('RIC') && !rightEnclousureType[0].name.includes("RIC")) ||
                    (!leftEnclousureType[0].name.includes('RIC') && rightEnclousureType[0].name.includes("RIC"))) {
                    return { state: false, msg: "RicTypeSelectionNote" };
                }
            }

            if (this.state.leftLine == -1) {
                return { state: false, msg: "LineRequired" };
            }
            else {
                let found = this.leftLines.find((i) => { return i.id === this.state.leftLine });
                if (!found) {
                    return { state: false, msg: "LineRequired" };
                }
            }

            if (this.state.rightLine == -1) {
                return { state: false, msg: "LineRequired" };
            }
            else {
                let found = this.rightLines.find((i) => { return i.id === this.state.rightLine });
                if (!found) {
                    return { state: false, msg: "LineRequired" };
                }
            }
            if (this.state.leftSpecsMatrix == -1) {
                return { state: false, msg: "MatrixSpecRequired" };
            }
            else {
                let found = this.leftSpecsMatrixes.find((i) => { return i.id === this.state.leftSpecsMatrix });
                if (!found) {
                    return { state: false, msg: "MatrixSpecRequired" };
                }
            }
            if (this.state.rightSpecsMatrix == -1) {
                return { state: false, msg: "MatrixSpecRequired" };
            }
            else {
                let found = this.rightSpecsMatrixes.find((i) => { return i.id === this.state.rightSpecsMatrix });
                if (!found) {
                    return { state: false, msg: "MatrixSpecRequired" };
                }
            }
        }

        if ((this.leftLineText && this.leftLineText.startsWith("Insio") && this.leftLineText.endsWith("AX")) ||
            (this.rightLineText && this.rightLineText.startsWith("Insio") && this.rightLineText.endsWith("AX"))) {
            orderService.setInsioAxOption(true);
        }
        else {
            orderService.setInsioAxOption(false);
        }

        if ((this.leftLineText && this.leftLineText.startsWith("BiCore Custom Li") && (this.leftLineText.endsWith("20") || this.leftLineText.endsWith("30") ||
            this.leftLineText.endsWith("40") || this.leftLineText.endsWith("60") || this.leftLineText.endsWith("80"))) ||
            (this.rightLineText && this.rightLineText.startsWith("BiCore Custom Li") && (this.rightLineText.endsWith("20") || this.rightLineText.endsWith("30") ||
                this.rightLineText.endsWith("40") || this.rightLineText.endsWith("60") || this.rightLineText.endsWith("80")))) {
            orderService.setBiCoreCustomLiOption(true);
        }
        else {
            orderService.setBiCoreCustomLiOption(false);
        }

        return { state: true }
    }

    setSpecialParameterByLine = async (line, leftRightOption, enclosureTypeId) => {
        let model = this.state.data;
        //console.log(line);
        if (line != -1) {
            // console.log(this.state.leftEnclousureType);
            let data = await this.getLinesLinkProductOptions(line, enclosureTypeId);
           // console.log(data);
            if (data) {
                const enclosureColors = data.map(item => item.productOption).filter(x => x.optionCategory == ProductOptionCategory.EnclosureColor);
                // console.log(data.map(item => item.productOption));
                const antiEarwaxDevice = data.map(item => item.productOption).filter(x => x.optionCategory == ProductOptionCategory.AntiEarwaxDevice);
                const attachment = data.map(item => item.productOption).filter(x => x.optionCategory == ProductOptionCategory.Attachment);
                const vent = data.map(item => item.productOption).filter(x => x.optionCategory == ProductOptionCategory.Vent);
                const onlyForRICSeries = data.map(item => item.productOption).filter(x => x.optionCategory == ProductOptionCategory.OnlyForRICSeries);

                const colorsToUse = enclosureColors.length > 0 ? enclosureColors : model.enclosureColors;
                const antiEarwaxDeviceToUse = antiEarwaxDevice.length > 0 ? antiEarwaxDevice : model.antiEarwaxDevice;
                const attachmentToUse = attachment.length > 0 ? attachment : model.defaultAttachment;
                const ventToUse = vent.length > 0 ? vent : model.vent;
                const onlyForRICSeriesToUse = onlyForRICSeries.length > 0 ? onlyForRICSeries : model.onlyForRICSeries;
              //  console.log(leftRightOption);
                if (leftRightOption === LeftRightOption.LeftEarOption) {
                    model.leftEnclosureColors = colorsToUse;
                    model.leftAntiEarwaxDevice = antiEarwaxDeviceToUse;
                    model.leftVent = ventToUse;
                    model.leftOnlyForRICSeries = onlyForRICSeriesToUse;
                    model.attachment = attachmentToUse;
                } else if (leftRightOption === LeftRightOption.RightEarOption) {
                    model.rightEnclosureColors = colorsToUse;
                    model.rightAntiEarwaxDevice = antiEarwaxDeviceToUse;
                    model.rightVent = ventToUse;
                    model.rightOnlyForRICSeries = onlyForRICSeriesToUse;
                    if (this.props.leftRightOption == LeftRightOption.RightEarOption) {
                        model.attachment = attachmentToUse;
                    }
                }

                this.setState({ data: model });
                // console.log(this.state.data);
            }
        } else {
          //  console.log("default");
            if (leftRightOption === LeftRightOption.LeftEarOption) {
                model.leftEnclosureColors = this.state.defaultEnclosureColors;
            } else if (leftRightOption === LeftRightOption.RightEarOption) {
                model.rightEnclosureColors = this.state.defaultEnclosureColors;
            }
        }

       

        if (this.props.leftRightOption === LeftRightOption.LeftEarOption) {
            this.setDefaultColorIfNeeded(model.leftEnclosureColors, 'leftColor');
        } else if (this.props.leftRightOption === LeftRightOption.RightEarOption) {
            this.setDefaultColorIfNeeded(model.rightEnclosureColors, 'rightColor');
        } else {
            this.setDefaultColorIfNeeded(model.leftEnclosureColors, 'leftColor');
            this.setDefaultColorIfNeeded(model.rightEnclosureColors, 'rightColor');
        }

    }

    getLinesLinkProductOptions = async (lineId, enclosureTypeId) => {
        if (lineId == -1) { return; }
        //console.log(lineId);
        const token = await authService.getAccessToken();
        const response = await fetch('ProductOption/GetLinesLinkProductOptions?lineId=' + lineId + "&enclosureTypeId=" + enclosureTypeId, {
            headers: !token ? {} : { 'Authorization': `${token}` }
        });
        if (response.status == 200) {
            let data = await response.json();
            return data;
        }
        else {
            console.error('response.status:' + response.status)
        }
    }
    setDefaultColorIfNeeded = (enclosureColors, stateColorKey) => {
        console.log(enclosureColors[0]);
        console.log(this.state[stateColorKey])
        //const defaultColor = this.state.defaultEnclosureColors[0].id;
        const currColor = this.state[stateColorKey];
        console.log(enclosureColors);
       
        if (enclosureColors && enclosureColors.length > 0) {
          //  console.log(enclosureColors[0]);
            const exists = enclosureColors.filter(obj => obj.id === currColor);
            if (currColor == -1 || exists.length == 0) {
                this.setState({ [stateColorKey]: enclosureColors[0].id });
            }
           
        }
    }
    render() {
        let items = [];

        let leftEnclosureColors = [];
        let rightEnclosureColors = [];
        let leftDesc = '';
        let leftProductCode = 'notexist';
        let leftRicCode = 'notexist';

        let rightDesc = '';
        let rightProductCode = 'notexist';
        let rightRicCode = 'notexist';
        //let antiEarwaxDeviceItems = null;
        //let ventItems = null;
        //let onlyForRICSeriesItems = null;
        // let attachmentItems = [];
        // let attachmentCode = '';
        //let otherOptions = [];
        //let cord = [];
        //let shellCoating = [];
        let data = this.state.data;
        //console.log(data);
        if (data) {
            //  antiEarwaxDeviceItems = data.antiEarwaxDevice;
            //  ventItems = data.vent;
            //  onlyForRICSeriesItems = data.onlyForRICSeries;
            //  attachmentItems = data.attachment;
            // otherOptions = data.otherOptions;
            // cord = data.cord;
            //  shellCoating = data.shellCoating;

            //for (let i = 0; i < attachmentItems.length; i++) {
            //    if (attachmentItems[i].id == this.state.attachment) {
            //        attachmentCode = attachmentItems[i].code;
            //        break;
            //    }
            //}
            items = data.enclosureTypes;

            const { leftEnclousureType, leftWireless, leftLine, leftSpecsMatrix } = this.state;
            let leftWL = parseInt(leftWireless);
            if (leftEnclousureType != "-1") {
                this.leftLines = this.getLines(leftEnclousureType, leftWL);
            }
            if (this.state.leftLine != "-1") {
                this.leftSpecsMatrixes = this.getMatrix(this.state.leftEnclousureType, this.state.leftLine, leftWL);
            }
            if (this.state.leftSpecsMatrix != "-1") {
                if (leftLine != "-1" && leftSpecsMatrix != "-1") {
                    let data = this.state.data;
                    if (data) {
                        let model = data.customizedMachineModel;
                        for (let i = 0; i < model.length; i++) {
                            if (model[i].enclosureType.id == leftEnclousureType && model[i].line.id == leftLine && model[i].specsMatrix.id == leftSpecsMatrix && leftWL == model[i].wireless) {
                                leftDesc = model[i].description;
                                leftProductCode = model[i].productCode;
                                leftRicCode = model[i].ricCode;
                                this.leftLineText = model[i].line.name;
                                break;
                            }
                        }
                    }
                }
            }
            const { rightEnclousureType, rightWireless, rightLine, rightSpecsMatrix } = this.state;
            let rightWL = parseInt(rightWireless);
            if (rightEnclousureType != "-1") {
                this.rightLines = this.getLines(rightEnclousureType, rightWL);
            }
            if (this.state.rightLine != "-1") {
                this.rightSpecsMatrixes = this.getMatrix(this.state.rightEnclousureType, this.state.rightLine, rightWL);
            }
            if (this.state.rightSpecsMatrix != "-1") {
                if (rightLine != "-1" && rightSpecsMatrix != "-1") {
                    let data = this.state.data;
                    if (data) {
                        let model = data.customizedMachineModel;

                        for (let i = 0; i < model.length; i++) {
                            if (model[i].enclosureType.id == rightEnclousureType && model[i].line.id == rightLine && model[i].specsMatrix.id == rightSpecsMatrix && rightWL == model[i].wireless) {
                                rightDesc = model[i].description;
                                rightProductCode = model[i].productCode;
                                rightRicCode = model[i].ricCode;
                                this.rightLineText = model[i].line.name;
                                break;
                            }
                        }
                    }
                }
            }
            leftEnclosureColors = data.leftEnclosureColors;
            rightEnclosureColors = data.rightEnclosureColors;

        
            // console.log(enclosureColors);
        }
        var isLeft = this.props.leftRightOption == LeftRightOption.LeftEarOption;
        var isRight = this.props.leftRightOption == LeftRightOption.RightEarOption;
        var disabledStyle = " bg-gray-200";
        let hasRic = { leftHasRic: leftDesc && leftDesc.includes("RIC"), rightHasRic: rightDesc && rightDesc.includes("RIC") }
        orderService.setHasRic(hasRic);



        //console.log(this.rightSpecsMatrixes);
        //console.log(this.leftSpecsMatrixes);

        return (
            <div>
                <div className="w-full">
                    <div className="border-b-2 border-blue-900 text-blue-800 font-bold"><h2><FormattedMessage id="CustomizedMachineModel" /></h2></div>
                    <div className="grid grid-cols-5 text-left text-sm">
                        <div className="grid grid-rows-3 py-1 border-b border-gray-300 text-left">
                            <label></label>
                            <div className="flex"><label className="place-self-center"><FormattedMessage id="EnclosureType" /></label></div>
                            <div className="text-red-500 text-xs"><label><FormattedMessage id="EnclosureTypeNote" /></label></div>
                        </div>
                        <div className="col-span-2">
                            <div className="bg-blue-200 flex justify-center items-center p-1">
                                <label className="mr-1"><FormattedMessage id="Left" /></label>
                                <div className="mx-auto flex-shrink-0 flex items-center justify-center h-4 w-4 lg:h-4 lg:w-4 rounded-full bg-blue-500 sm:mx-0 sm:h-5 sm:w-5">
                                    <label className="text-white">L</label>
                                </div>
                            </div>

                            {items.map((item, index) =>
                                <div key={index} className="grid grid-cols-2 mt-1 py-1 border-b border-gray-300">
                                    <img className="w-24 h-12 bg-blue-200 rounded-md" src={item.imageUrl} onError={(e) => { e.target.src = DefaultImage }} />
                                    <div className="flex flex-col justify-center items-center p-1">
                                        <label id={'l' + item.id}>{item.name}</label>
                                        <input disabled={this.props.leftRightOption === LeftRightOption.RightEarOption} className={"mx-1 text-xs" + (isRight ? disabledStyle : "")} type="radio" name="leftEnclousureType" onChange={this.handleLeftChange} checked={this.state.leftEnclousureType === item.id} value={item.id} />
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="col-span-2">
                            <div className="bg-red-200 flex justify-center items-center p-1">
                                <label className="mr-1"><FormattedMessage id="Right" /></label>
                                <div className="mx-auto flex-shrink-0 flex items-center justify-center h-4 w-4 lg:h-4 lg:w-4 rounded-full bg-red-500 sm:mx-0 sm:h-5 sm:w-5">
                                    <label className="text-white">R</label>
                                </div>
                            </div>
                            {items.map((item, index) =>
                                <div key={index} className="grid grid-cols-2 mt-1 py-1 border-b border-gray-300">
                                    <img className="w-24 h-12 bg-red-200 rounded-md" src={item.imageUrl} onError={(e) => { e.target.src = DefaultImage }} />
                                    <div className="flex flex-col justify-center items-center">
                                        <label id={'r' + item.id}>{item.name}</label>
                                        <input disabled={this.props.leftRightOption === LeftRightOption.LeftEarOption} className={"mx-1 text-xs" + (isLeft ? disabledStyle : "")} type="radio" name="rightEnclousureType" onChange={this.handleRightChange} checked={this.state.rightEnclousureType === item.id} value={item.id} />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="w-full mt-1  text-sm">
                    <div className="grid place-content-stretch gap-y-1 h-full">
                        <div className="grid grid-cols-5 text-left">
                            <label><FormattedMessage id="IsWireless" /></label>
                            <div className="col-span-2">
                                <input className={"mr-4" + (isRight ? disabledStyle : "")} type="radio" disabled={isRight ? "disabled" : ""} name="leftWireless" onChange={this.handleLeftChange} checked={this.state.leftWireless === "0" && !isRight} value="0" />无
                                <input className={"mx-4" + (isRight ? disabledStyle : "")} type="radio" disabled={isRight ? "disabled" : ""} name="leftWireless" onChange={this.handleLeftChange} checked={this.state.leftWireless === "1" && !isRight} value="1" />WL
                            </div>
                            <div className="col-span-2">
                                <input className={"mr-4" + (isLeft ? disabledStyle : "")} type="radio" disabled={isLeft ? "disabled" : ""} name="rightWireless" onChange={this.handleRightChange} checked={this.state.rightWireless === "0" && !isLeft} value="0" />无
                                <input className={"mx-4" + (isLeft ? disabledStyle : "")} type="radio" disabled={isLeft ? "disabled" : ""} name="rightWireless" onChange={this.handleRightChange} checked={this.state.rightWireless === "1" && !isLeft} value="1" />WL
                            </div>
                        </div>
                        <div className="grid grid-cols-5 text-left">
                            <div className="flex">
                                <label className="place-self-center"><FormattedMessage id="Line" /></label>
                            </div>
                            <BaseCombobox classnames={"col-span-2" + (isRight ? disabledStyle : "")} name="leftLine" disabled={isRight ? "disabled" : ""} value={this.state.leftLine} onChange={this.handleLeftChange}>
                                <FormattedMessage id="PickOne" >
                                    {text => <option value="-1">{text}</option>}
                                </FormattedMessage>
                                {this.leftLines.map((i, index) => <option key={index} value={i.id}>{i.name}</option>)}
                            </BaseCombobox>
                            <BaseCombobox classnames={"col-span-2" + (isLeft ? disabledStyle : "")} name="rightLine" disabled={isLeft ? "disabled" : ""} value={this.state.rightLine} onChange={this.handleRightChange}>
                                <FormattedMessage id="PickOne" >
                                    {text => <option value="-1">{text}</option>}
                                </FormattedMessage>
                                {this.rightLines.map((i, index) => <option key={index} value={i.id}>{i.name}</option>)}
                            </BaseCombobox>
                        </div>
                        <div className="grid grid-cols-5 text-left">
                            <div className="flex">
                                <label className="place-self-center"><FormattedMessage id="SpecsMatrix" /></label>
                            </div>
                            <BaseCombobox classnames={"col-span-2" + (isRight ? disabledStyle : "")} name="leftSpecsMatrix" disabled={isRight ? "disabled" : ""} value={this.state.leftSpecsMatrix} onChange={this.handleLeftChange}>
                                <FormattedMessage id="PickOne" >
                                    {text => <option value="-1">{text}</option>}
                                </FormattedMessage>
                                {this.leftSpecsMatrixes.map((i, index) => <option key={index} value={i.id}>{i.name}</option>)}
                            </BaseCombobox>
                            <BaseCombobox classnames={"col-span-2" + (isLeft ? disabledStyle : "")} name="rightSpecsMatrix" disabled={isLeft ? "disabled" : ""} value={this.state.rightSpecsMatrix} onChange={this.handleRightChange} >
                                <FormattedMessage id="PickOne" >
                                    {text => <option value="-1">{text}</option>}
                                </FormattedMessage>
                                {this.rightSpecsMatrixes.map((i, index) => <option key={index} value={i.id}>{i.name}</option>)}
                            </BaseCombobox>
                        </div>
                        <div className="grid grid-cols-5 text-left">
                            <div className="flex">
                                <label className="place-self-center"><FormattedMessage id="EnclosureColor" /></label>
                            </div>
                            <BaseCombobox classnames={"col-span-2" + (isRight ? disabledStyle : "")} name="leftEnclosureColor" disabled={isRight ? "disabled" : ""} value={this.state.leftColor} onChange={this.handleLeftChange}>
                                {/*<option value={this.state.defaultLeftColor}>{this.state.defaultLeftColor === "-2" ? "默认(黑色) Default Color" : "默认 Default Color"}</option>*/}
                                {leftEnclosureColors.map((i, index) => <option key={index} value={i.id}>{i.name}</option>)}
                            </BaseCombobox>
                            <BaseCombobox classnames={"col-span-2" + (isLeft ? disabledStyle : "")} name="rightEnclosureColor" disabled={isLeft ? "disabled" : ""} value={this.state.rightColor} onChange={this.handleRightChange}>
                                {/*     <option value={this.state.defaultRightColor}>{this.state.defaultRightColor === "-2" ? "默认(黑色) Default Color" : "默认 Default Color"}</option>*/}
                                {rightEnclosureColors.map((i, index) => <option key={index} value={i.id}>{i.name}</option>)}
                            </BaseCombobox>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="w-1/2 inline-block">
                        <table className="border-b-2 border-blue-300 w-full">
                            <tbody>
                                <tr>
                                    <td colSpan="2">
                                        <div className="border-2 border-blue-300 flex flex-row">
                                            <div className="bg-blue-500 h-8 w-12 flex flex-row items-center">
                                                <label className="text-white mr-1 "><FormattedMessage id="Left" /></label>
                                                <div className="mx-auto flex-shrink-0 flex items-center justify-center h-4 w-4 lg:h-4 lg:w-4 rounded-full bg-gray-50 sm:mx-0 sm:h-5 sm:w-5">
                                                    <label className="text-blue-500">L</label>
                                                </div>
                                            </div>
                                            <label className="place-self-center px-2 truncate w-full">{leftDesc}</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="py-1">
                                        <div className="flex">
                                            <div className="flex flex-col items-center  gap-y-1">
                                                <BaseBarcode value={leftProductCode} />
                                                <div className="text-blue-300 text-center" ><FormattedMessage id="ProductCode" /></div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="flex">
                                            <div className="flex flex-col items-center  gap-y-1"><BaseBarcode value={leftRicCode} />
                                                <div className="text-blue-300 text-center" ><FormattedMessage id="RicCode" /></div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="w-1/2 inline-block mt-4">
                        <table className="border-b-2 border-red-300 w-full">
                            <tbody>
                                <tr><td colSpan="2">
                                    <div className="border-2 border-red-300 flex flex-row mt-1">
                                        <div className="bg-red-500 h-8 w-12 flex flex-row items-center">
                                            <label className="text-white  mr-1"><FormattedMessage id="Right" /></label>
                                            <div className="mx-auto flex-shrink-0 flex items-center justify-center h-4 w-4 lg:h-4 lg:w-4 rounded-full bg-gray-50 sm:mx-0 sm:h-5 sm:w-5">
                                                <label className="text-red-500">R</label>
                                            </div>
                                        </div>
                                        <label className="place-self-center px-2 truncate w-full">{rightDesc}</label>
                                    </div>
                                </td></tr>
                                <tr>
                                    <td className="py-1">
                                        <div className="flex">
                                            <div className="flex flex-col items-center gap-y-1">
                                                <BaseBarcode value={rightProductCode} />
                                                <div className="text-red-300 text-center" ><FormattedMessage id="ProductCode" /></div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="flex">
                                            <div className="flex flex-col items-center gap-y-1">
                                                <BaseBarcode value={rightRicCode} />
                                                <div className="text-red-300 text-center" ><FormattedMessage id="RicCode" /></div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}
